import { CreateFirstClubEvent } from './CreateFirstClubEvent';

export default CreateFirstClubEvent;
